import React, { createContext, useState,useEffect } from "react";
import { toast } from "react-hot-toast";
import FirebaseJwt from '@presswink/firebase-jwt';
import { useNavigate } from "react-router-dom";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
   const projectId= "abcdefghijklmnoplqrst";
   const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null); // To store decoded user data
 
  // console.log("user",user);
  const [isLoading, setIsLoading] = useState(true);
  const login = async (email, password) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        email,
        password,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(`${process.env.REACT_APP_BASEURL}api.php/login`, requestOptions);
      

      const result = await response.json();
      
      const jwt = new FirebaseJwt(projectId);
     

      if (result.status === "success") {
        setIsLoggedIn(true);

        // Store token in localStorage
        localStorage.setItem("authToken", result.token);

    
        const decodeResult = jwt.decode(result.token)
        // console.log('sdfgv  ',decodeResult)
        setUser(decodeResult);

        toast.success("Login successful");
        return { success: true, token: result.token };
      } else {
        setIsLoggedIn(false);
        toast.error("Login failed");
        return { success: false, message: result.message || "Login failed" };
      }
    } catch (error) {
      toast.error("Something went wrong!");
      return { success: false, message: "Something went wrong!" };
    }
  };
  const logout = () => {
    // Clear user data and token
    
    setIsLoggedIn(false);
    setUser(null);
    localStorage.removeItem("authToken");
    
    navigate("/");
   // console.log('firsdfgdfgdfgsdsfdfsgt')
    toast.success("Logged out successfully");
  };
  

  
  useEffect(() => {
    // console.log("dbgfvkb")
    const validateToken = async () => {
      const token = localStorage.getItem("authToken");
      if (token) {  
        const jwt = new FirebaseJwt(projectId);
        try {
          const decodedUser = jwt.decode(token);
         

          setUser(decodedUser);
          setIsLoggedIn(true);

          
        } catch (error) {
          
           
          setIsLoggedIn(false);
          
        }
      }
      
      setIsLoading(false); 
    };
    
    validateToken();
  }, []);

  




  //new

  

  return (
    <AuthContext.Provider value={{ login, logout, isLoggedIn, setIsLoggedIn, user, isLoading, setUser }}>
       {!isLoading ? children : <div className="loader">Loading...</div>}
    </AuthContext.Provider>
  );
};
